function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnWorkGetwet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.56,
    y: 2.32,
    width: 29.66,
    height: 30.68,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 10.66,
    ry: 10.66,
    style: {
      fill: "#16db44",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    d: "m8.25,26.05c.39-.75,1.14-1.26,1.99-1.34,2.26,0,3.64.16,5.61-1.81,2.93-2.93,5.58-2.19,5.58-2.19-.34-2.36-10.43-7.45-13.18,5.34",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    d: "m32.22,11.33s-.9.15-.9,1.97c0,2.03-3.37,4.37-4.98,4.68-3.17.6-4.27,2.5-4.27,2.5-.64-4.09-.53-10.5,10.15-9.14",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    d: "m21.03,19.16c1.59,3.8,1.82,8.11.13,13.16.14.67.61.84,1.39.53,1.92-3.08,1.18-10.82-1.51-13.69",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    d: "m10.94,12c.35.94-.13,1.99-1.07,2.34-.94.35-1.99-.13-2.34-1.07h0c-.48-1.3-.32-4.36.24-4.57.56-.21,2.69,1.99,3.18,3.3",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    d: "m15.31,13.39c.42.7.18,1.61-.52,2.02-.7.42-1.61.18-2.02-.52-.57-.96-.88-3.44-.47-3.68s2.43,1.2,3.01,2.18",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    d: "m14.79,7.02c1.05.28,1.68,1.36,1.4,2.42-.28,1.05-1.36,1.68-2.42,1.4-.01,0-.03,0-.04-.01-1.44-.4-4.02-2.5-3.85-3.12s3.46-1.08,4.91-.68",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWorkGetwet);
export default __webpack_public_path__ + "static/media/icn-work-getwet.9a3926eb194a1ff592eee84025dffb0e.svg";
export { ForwardRef as ReactComponent };